import * as React from 'react';
import { Container, Header, Left, Button, Icon, Body, Title, Right, Content, Card, CardItem, Text, H2, View, H3, Spinner } from 'native-base';
import { StyleSheet } from 'react-native';

class SubscriptionContainer extends React.Component {
	render() {
		//we should log out before this so changes are picked up
		window.location = 'https://calcal.uk/membership-account/membership-levels/';
		return (
			<Container>
				<Header>
					<Left style={{ width: 40, flex: 0 }}>
						<Button transparent onPress={() => this.props.navigation.navigate({ name: 'Stack' })}>
							<Icon active name="ios-arrow-back" />
						</Button>
					</Left>
					<Body style={{ flex: 1 }}>
						<Title>Subscription</Title>
					</Body>
					<Right style={{ width: 40, flex: 0 }}>
						<Button transparent>
							<Icon active name="ios-refresh" />
						</Button>
					</Right>
				</Header>
				<Content padder>
					<Text>Taking you to the subscription page</Text>
				</Content>
			</Container>
		);
	}
}

export default SubscriptionContainer;
